import React, { createContext, useContext } from 'react';
import { useGeneratorState } from '../hooks/useGeneratorState';

const DEFAULT_CONTEXT_VALUE = null;
const ERR_MISSING_PROVIDER = 'useGeneratorContext must be used within GeneratorStateProvider';

const GeneratorStateContext = createContext(DEFAULT_CONTEXT_VALUE);

export const GeneratorStateProvider = ({ children }) => {
    const generatorState = useGeneratorState();

    return (
        <GeneratorStateContext.Provider value={generatorState}>
            {children}
        </GeneratorStateContext.Provider>
    );
};

export const useGeneratorContext = () => {
    const context = useContext(GeneratorStateContext);
    if (!context) {
        throw new Error(ERR_MISSING_PROVIDER);
    }
    return context;
};

export default GeneratorStateContext;
